import { z } from 'zod';

export const Currency = z.enum(['JPY', 'USD']);

export type Currency = z.infer<typeof Currency>;

export const CurrencyPair = z.enum(['JPY_USD']);

export type CurrencyPair = z.infer<typeof CurrencyPair>;
